(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dastaan-product-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class DastaanBookTabs extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        const list = this.querySelector('[data-tab-list]');
        if (!list || this.tabs.length !== this.panels.length) return;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(index);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            const rtl = getComputedStyle(list).direction === 'rtl';
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') { event.preventDefault(); this.select(index); return; }
            else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        const hashIndex = this.panels.findIndex((panel) => `#${panel.id}` === location.hash);
        this.select(Math.max(0, hashIndex), false);
      }

      select(index, animate = true) {
        this.panelAnimation?.cancel();
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(index === i));
          tab.tabIndex = index === i ? 0 : -1;
          this.panels[i].hidden = index !== i;
        });
        const panel = this.panels[index];
        if (animate && !reducedMotion() && panel.animate) {
          this.panelAnimation = panel.animate([{ opacity: .35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 250, easing: 'ease-out' });
        }
      }

      disconnectedCallback() { this.controller?.abort(); this.panelAnimation?.cancel(); }
    }

    class DastaanDelivery extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.updateDates();
        clearInterval(this.timer);
        this.timer = setInterval(() => this.updateDates(), 60000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.updateDates();
        }, { signal: this.controller.signal });
        this.observer?.disconnect();
        if ('IntersectionObserver' in window && !reducedMotion()) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          }, { threshold: .25 });
          this.observer.observe(this);
        } else this.classList.add('is-visible');
      }

      updateDates() {
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: this.dataset.timezone || 'Asia/Karachi', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const part = (type) => Number(parts.find((item) => item.type === type)?.value);
        const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
        const key = today.toISOString();
        if (key === this.dateKey) return;
        this.dateKey = key;
        const offset = (name, fallback) => {
          const value = Number.parseInt(this.dataset[name], 10);
          return Number.isFinite(value) ? Math.max(0, Math.min(365, value)) : fallback;
        };
        const dispatchMin = offset('dispatchMin', 0);
        const dispatchMax = Math.max(dispatchMin, offset('dispatchMax', 1));
        const deliveryMin = Math.max(dispatchMin, offset('deliveryMin', 2));
        const deliveryMax = Math.max(deliveryMin, dispatchMax, offset('deliveryMax', 4));
        const addDays = (days) => { const date = new Date(today); date.setUTCDate(date.getUTCDate() + days); return date; };
        const format = (date) => new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', timeZone: 'UTC' }).format(date);
        const range = (min, max) => {
          const start = addDays(min), end = addDays(max);
          if (min === max) return format(start);
          if (start.getUTCFullYear() !== end.getUTCFullYear()) return `${format(start)} ${start.getUTCFullYear()} – ${format(end)} ${end.getUTCFullYear()}`;
          if (start.getUTCMonth() === end.getUTCMonth()) return `${String(start.getUTCDate()).padStart(2, '0')} – ${format(end)}`;
          return `${format(start)} – ${format(end)}`;
        };
        const set = (selector, value) => { const element = this.querySelector(selector); if (element) element.textContent = value; };
        set('[data-order-date]', format(today));
        set('[data-dispatch-date]', range(dispatchMin, dispatchMax));
        set('[data-delivered-date]', range(deliveryMin, deliveryMax));
        const estimate = this.querySelector('[data-estimated-delivery]');
        if (estimate) {
          const strong = document.createElement('strong');
          strong.textContent = range(deliveryMin, deliveryMax);
          estimate.replaceChildren(strong, document.createTextNode(` ${this.dataset.estimateLabel || ''}`));
        }
      }

      disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
    }

    class DastaanUpsellSlider extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.track = this.querySelector('[data-upsell-track]');
        this.slides = Array.from(this.querySelectorAll('.dp-upsell__slide'));
        this.prevBtn = this.querySelector('[data-upsell-prev]');
        this.nextBtn = this.querySelector('[data-upsell-next]');
        this.counter = this.querySelector('[data-upsell-counter]');
        this.status = this.querySelector('[data-upsell-status]');
        this.currentIndex = 0;

        if (this.slides.length <= 1) {
          if (this.prevBtn) this.prevBtn.hidden = true;
          if (this.nextBtn) this.nextBtn.hidden = true;
          if (this.counter) this.counter.hidden = true;
        }

        this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1), { signal });
        this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1), { signal });

        this.querySelectorAll('[data-upsell-variant]').forEach((select) => {
          select.addEventListener('change', (e) => {
            const opt = e.target.selectedOptions?.[0];
            if (!opt) return;
            const slide = e.target.closest('.dp-upsell__slide');
            const priceEl = slide?.querySelector('[data-upsell-price]');
            const compareEl = slide?.querySelector('[data-upsell-compare]');
            const addBtn = slide?.querySelector('[data-upsell-add]');
            if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
            if (compareEl) {
              if (opt.dataset.compare) {
                compareEl.textContent = opt.dataset.compare;
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
            if (addBtn) addBtn.dataset.variantId = opt.value;
          }, { signal });
        });

        this.querySelectorAll('[data-upsell-add]').forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const variantId = btn.dataset.variantId;
            if (!variantId || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
            btn.setAttribute('aria-busy', 'true');
            btn.disabled = true;
            if (this.status) this.status.textContent = 'Adding to cart...';

            try {
              const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                  sections: 'cart-drawer-section'
                })
              });

              if (!res.ok) {
                const errData = await res.json().catch(() => ({}));
                throw new Error(errData.description || 'Could not add item to cart.');
              }

              const data = await res.json();
              if (this.status) this.status.textContent = 'Added to cart!';

              const drawerSection = data.sections?.['cart-drawer-section'];
              if (drawerSection) {
                const target = document.getElementById('shopify-section-cart-drawer-section');
                if (target) {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(drawerSection, 'text/html');
                  const newDrawer = doc.querySelector('#shopify-section-cart-drawer-section') || doc.body.firstElementChild;
                  if (newDrawer) target.replaceWith(newDrawer);
                }
              }

              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
              document.dispatchEvent(new CustomEvent('cart:refresh'));

              const drawer = document.getElementById('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else {
                const drawerToggle = document.querySelector('[data-drawer-open="cart-drawer"], [aria-controls="cart-drawer"]');
                drawerToggle?.click();
              }

              const textSpan = btn.querySelector('.dp-upsell__btn-text');
              const origText = textSpan ? textSpan.textContent : '';
              if (textSpan) textSpan.textContent = 'Added!';
              setTimeout(() => {
                if (textSpan) textSpan.textContent = origText;
                btn.removeAttribute('aria-busy');
                btn.disabled = false;
                if (this.status) this.status.textContent = '';
              }, 2000);
            } catch (err) {
              console.error(err);
              if (this.status) this.status.textContent = err.message || 'Error adding to cart';
              btn.removeAttribute('aria-busy');
              btn.disabled = false;
            }
          }, { signal });
        });

        this.updateControls();
      }

      goTo(index) {
        if (!this.slides.length) return;
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;
        if (this.track) {
          this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        }
        this.updateControls();
      }

      updateControls() {
        if (this.counter && this.slides.length) {
          this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    }

    if (!customElements.get('dastaan-book-tabs')) customElements.define('dastaan-book-tabs', DastaanBookTabs);
    if (!customElements.get('dastaan-delivery')) customElements.define('dastaan-delivery', DastaanDelivery);
    if (!customElements.get('dastaan-upsell-slider')) customElements.define('dastaan-upsell-slider', DastaanUpsellSlider);

    const animations = new WeakMap();
    document.addEventListener('click', (event) => {
      const summary = event.target.closest?.('.dastaan-product .product-details .accordion summary');
      if (!summary || event.defaultPrevented) return;
      const details = summary.parentElement;
      const wrapper = details.closest('accordion-custom');
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      if (wrapper?.dataset[mobile ? 'disableOnMobile' : 'disableOnDesktop'] === 'true') return;
      if (reducedMotion() || !details.animate) return;
      event.preventDefault();
      const previous = animations.get(details);
      const opening = previous ? !previous.opening : !details.open;
      const startHeight = details.getBoundingClientRect().height;
      previous?.animation.cancel();
      details.classList.add('accordion-custom-fallback');
      details.style.overflow = 'hidden';
      details.style.height = '';
      details.open = true;
      const endHeight = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      const animation = details.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      animations.set(details, { animation, opening });
      animation.onfinish = () => {
        details.open = opening;
        details.style.overflow = '';
        details.style.height = '';
        animations.delete(details);
        details.classList.remove('accordion-custom-fallback');
      };
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
